import {WalletService} from "@/services/wallet.service";
import moment from "moment";

const state = {
    loading: false,
    dialog: false,
    dialog_cashout: false,
    overlay: false,
    total_cashin: 0,
    total_cashout: 0,
    total_histori: 0,
    cashin: [],
    cashout: [],
    wallethistori: [],
    banks: [],
    walletbanks: [],
    total_walletbank: 0,
    wallet: {
        status: 1,
        balance: 0,
        unclear: 0,
        pendingcashout: 0,
        pendingBalance: 0,
        wallettype: 0
    }
}
const actions = {
    opendialog({ commit }) {
        commit('opendialog');
    },
    opendialogcashout({ commit }) {
        commit('opendialogcashout');
    },
    closedialogcashout({ commit }) {
        commit('closedialogcashout');
    },
    closedialog({ commit }) {
        commit('closedialog');
        commit('setloading',true);
        WalletService.getWallet().then(data=>{
            commit('setloading',false);
            commit('addWalletData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    deleteWalletbank({ commit },id){
        commit('setloading',true);
        commit('setloading',true);
        WalletService.deleteBanks(id).then(data=>{
            console.log(data)
            commit('closedialog');
            WalletService.getWallet().then(data=>{
                commit('setloading',false);
                commit('addWalletData', data);
            }).catch(error=>{
                commit('setloading',false);
                console.log(error);
            });
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        })
    },
    addWalletbank({ dispatch, commit },postdata){
      if(!postdata.otp) dispatch('alert/error', "Silahkan Input OTP", { root: true });
      else {
        commit('setloading',true);
        WalletService.addBanks(postdata).then(data=>{
              dispatch('alert/success', data.msg, { root: true });
              commit('closedialog');
              WalletService.getWallet().then(data=>{
                  commit('setloading',false);
                  commit('addWalletData', data);
              }).catch(error=>{
                  commit('setloading',false);
                  console.log(error);
              });
          }).catch(error=>{
            commit('setloading',false);
            console.log(error);
            dispatch('alert/error', error, { root: true });
          })
      }
    },
    getWallet({ commit }){
        console.log("get wallet")
        commit('setloading',true);
        WalletService.getWallet().then(data=>{
            commit('setloading',false);
            commit('addWalletData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getCashin({ commit },opti){
        commit('setloading',true);
        WalletService.getCashin(opti).then(data=>{
            commit('setloading',false);
            commit('addCashinData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getCashOut({ commit },opti){
        commit('setloading',true);
        WalletService.getCashOut(opti).then(data=>{
            commit('setloading',false);
            commit('addCashOutData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getHistoriWallet({ commit },opti){
        commit('setloading',true);
        WalletService.getWalletHistori(opti).then(data=>{
            commit('setloading',false);
            commit('addWalletHistoriData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getWalletBanks({ commit },opti){
        commit('setloading',true);
        WalletService.getBanks(opti).then(data=>{
            commit('setloading',false);
            commit('addBanks', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getOtp({dispatch, commit},detail){
      commit('setloading',true);
      WalletService.getOtp(detail).then(() => {
          commit('setloading',false);
          dispatch('alert/success', "Otp sukses di kirim ke email", { root: true });
        }).catch(err => {
          console.log("=====ERROR SEND OTP=====")
          console.log(err)
          commit('setloading',false);
          dispatch('alert/error', err || "Otp gagal di kirim", { root: true });
        })
    },
    docashout({ dispatch,commit },data){
      if(!data.otp) dispatch('alert/error', "Silahkan Input OTP", { root: true });
      else {
        commit('setloading',true);
        WalletService.doCashOut(data).then(data=>{
            commit('setloading',false);
            commit('closedialogcashout');
            dispatch('alert/success', data.msg, { root: true });

            var opti= {
                search:'',
                    itemsPerPage: 10,
                    page:1,
                    sortBy: ["id"],
                    awal: moment().add(7,'hours').toISOString().substr(0, 10),
                    akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            }
            commit('setloading',true);
            WalletService.getCashOut(opti).then(data=>{
                commit('setloading',false);
                commit('addCashOutData', data);
            }).catch(error=>{
                commit('setloading',false);
                console.log(error);
            });

        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
            dispatch('alert/error', error, { root: true });
        })
        }
      }
}
const mutations = {
    closedialog(state){
        state.dialog = false
    },
    opendialog(state){
        state.dialog = true
    },
    closedialogcashout(state){
        state.dialog_cashout = false
    },
    opendialogcashout(state){
        state.dialog_cashout = true
    },
    setloading(state,load) {
        state.loading = load
        state.overlay = load
    },
    addWalletData(state, w) {
        state.wallet.balance= w.data.balance
        state.wallet.unclear= w.data.unclear
        state.wallet.status = w.data.status
        state.wallet.pendingcashout=w.data.pendingcashout
        state.wallet.pendingBalance=w.data.pendingBalance
        state.wallet.type = w.data.wallettype
        state.walletbanks = []
        state.walletbanks= w.data.banks
        state.total_walletbank = w.data.banks.length
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
    addCashinData(state, cashindata) {
        state.cashin = []
        state.cashin= cashindata.data.content
        state.total_cashin = cashindata.data.totalElements
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
    addCashOutData(state, cashoutdata) {
        state.cashout = []
        state.cashout= cashoutdata.data.content
        state.total_cashout = cashoutdata.data.totalElements
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
    addWalletHistoriData(state, wallethistory) {
        state.wallethistori = []
        state.wallethistori= wallethistory.data.content
        state.total_histori = wallethistory.data.totalElements
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
    addWalletBankdata(state, a) {
        state.walletbanks = []
        state.walletbanks= a.data.content
        state.walletbanks = a.data.totalElements
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
    addBanks(state, a) {
        state.banks = []
        state.banks= a.data.content
        state.banks = a.data.totalElements
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
}

export const Wallet = {
    namespaced: true,
    state,
    actions,
    mutations
};
